import React from 'react'
import Checkbox from '@mui/material/Checkbox'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType';
import {css} from '@emotion/react'
import {useCFAttrTextAlignCSS} from 'module/CustomField/style/CFAlignmentStyle'

const cssCheckbox = css`
	margin: -9px;
	// (@ghi) do not use text-align: center; forms should align left!
`

export function JaNeinCheckboxComponent({modelValue, cfDef, disabled, setCb}: CFComponentProps<'J' | 'N'>) {
	const checked = modelValue === 'J';
	return (
		<div css={[cssCheckbox, useCFAttrTextAlignCSS(cfDef)]}>
			<Checkbox
				color={'primary'}
				checked={checked}
				disabled={disabled}
				onChange={() => !disabled && setCb(checked ? 'N' : 'J')}
			/>
		</div>
	);
}